import React, { useEffect, useState, useCallback } from "react";
import Autocomplete from "react-google-autocomplete";
import Faq from "react-faq-component";
import { useNavigate } from "react-router-dom";

import "./index.css";
import axios from "../axios";
import { logEvent, logPageView } from "../analytics";
import { citysList, qualifications, socialplatforms, EVENTS, FaqData } from "../constants";
import TutorsReviewComponent from "../components/TutorReview/TutorReview";
import WhyChooseHomeShiksha from "../components/WhyChooseHomeshiksha/WhyChooseHomeshiksha";
import PlatformReviewComponent from "../components/PlatformReviews/PlatformReview";
import Footer from "../components/Footer/Footer";

const apiKey = (window._env_ && window._env_.REACT_APP_GOOGLE_MAPS_API_KEY) || process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const config = {
  animate: true,
  // arrowIcon: "V",
  // tabFocus: true,
  tabFocus: false,
  expandIcon: "+",
  collapseIcon: "-",
};

export default function TutorRegister() {
  const [currentStep, setCurrentStep] = useState(0);
  const [smsOtpVerification, setSmsOtpVerification] = useState(false);
  const [errors, setErrors] = useState({});

  const [otp, setOtp] = useState();
  const [showResendOtp, setShowResendOtp] = useState(false);
  const [verificationProcess, setVerificationProcess] = useState(false);
  const [showTC, setShowTC] = useState(false);
  const [Form, setForm] = useState([
    {
      viewed: true,
      filled: false,
      fields: [
        { type: "text", name: "First Name", placeHolder: "Enter Your First Name", value: "" },
        { type: "text", name: "Last Name", placeHolder: "Enter Your Last Name", value: "" },
        {
          type: "dropDown",
          open: true,
          name: " Your Gender",
          placeHolder: "Select Your Gender",
          options: ["male", "female"],
          value: "",
        },
        { type: "tel", name: "Mobile", placeHolder: "Enter Your 10 Digit Mobile Number", value: "" },
        { type: "email", name: "Email", placeHolder: "Enter Your Email", value: "" },
      ],
    },
    {
      viewed: false,
      filled: false,
      fields: [
        {
          type: "dropDown",
          open: true,
          name: "Select Mode of Teaching ?",
          placeHolder: "Select Mode of Teaching",
          options: ["Offline Home Tutions"],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "Teaching Experience (in years)",
          placeHolder: "Select Teaching Experience",
          options: [
            "Fresher",
            "1 year",
            "2 years",
            "3 years",
            "4 years",
            "5 years",
            "6 years",
            "7 years",
            "8 years",
            "9 years",
            "10 years",
            "11 years",
            "12 years",
            "13 years",
            "14 years",
            "15 years",
            "16 years",
            "17 years",
            "18 years",
            "19 years",
            "20 years",
            "21 years",
            "22 years",
            "23 years",
            "24 years",
            "25 years",
            "26 years",
            "27 years",
            "28 years",
            "29 years",
            "30 years",
            ">30 years",
          ],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: " Your Qualification",
          placeHolder: "Select Qualification",
          options: qualifications,
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "What you are looking ?",
          placeHolder: "What you are looking ?",
          options: ["Looking for Part Time Tuitions", "Looking for Full time Teaching Job", "Both"],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "From where you got to know about us",
          placeHolder: "From where you got to know about us",
          options: socialplatforms,
          value: "",
        },
      ],
    },
    {
      viewed: false,
      filled: false,
      fields: [
        {
          type: "dropDown",
          open: false,
          name: "Vehicle Owned ?",
          placeHolder: "Vehicle Owned ?",
          options: ["Yes", "No"],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "Which City you are from ?",
          placeHolder: "Select City",
          options: citysList,
          value: "",
        },
        {
          type: "address",
          name: "Location",
          placeHolder: "Search for Apartment / Building / Society / locality….",
          value: "",
        },
        {
          type: "checkbox",
          name: "",
          placeHolder: "",
          value: false,
        },
      ],
    },
    {
      viewed: false,
      filled: false,
      fields: [{ type: "verificationBtn", name: "OTP", placeHolder: "Enter Your OTP", value: "" }],
    },
  ]);
  const [showOtpError, setShowOtpError] = useState("");
  const [activeRow, setActiveRow] = useState(null);
  const navigate = useNavigate();

  const makeTitle = (string) => {
    try {
      let arr = string.split(" ");
      arr = arr.map((itm) => itm.charAt(0).toUpperCase() + itm.slice(1));
      return arr.join(" ");
    } catch (error) {
      return string;
    }
  };

  const registerAndGetOTP = (login_method = "sms") => {
    let obj = {};
    obj = {
      ...obj,
      first_name: Form[0].fields[0].value,
      last_name: Form[0].fields[1].value,
      gender: Form[0].fields[2].value,
      phone: Form[0].fields[3].value,
      email: Form[0].fields[4].value,

      teching_mode: Form[1].fields[0].value,
      experience: Form[1].fields[1].value,
      qualification: Form[1].fields[2].value,
      teching_type: Form[1].fields[3].value,
      reference: Form[1].fields[4].value,

      do_you_have_vehicle: Form[2].fields[0].value,

      city_name: Form[2].fields[1].value,
      state_name: Form[2].fields[2].value.state,
      locality: Form[2].fields[2].value.locality,
      gmap_meta_data: Form[2].fields[2].value.gmap_meta_data,
      zip: Form[2].fields[2].value.pincode,
      latitude: Form[2].fields[2].value.latitude,
      longitude: Form[2].fields[2].value.longitude,
    };

    axios
      .post("/v1/tutor-register", obj)
      .then((res) => {
        return axios.post(`v1/generateOtp`, {
          phoneNo: obj.phone,
          login_method,
          user_type: "Tutor",
        });
      })
      .then((data) => {
        data = data.data;
        if (!data.is_success) {
          setShowOtpError(() => data.error.msg);
          return;
        }
        let otp = data.data.otp;
        setOtp(otp);
        if (login_method === "whatsapp") {
          const whatsappLink = `https://wa.me/917386936695?text=Log%20me%20in%20to%20Homeshiksha%20%3A%20H-${otp}`;
          setTimeout(() => {
            window.open(whatsappLink, "_blank");
          });
          checkForJWT("whatsapp", otp);
        }
      })
      .catch((err) => { });
  };

  const checkForJWT = (login_method, otp = "") => {
    let findTokenInterval = setInterval(() => {
      getJWT(findTokenInterval, login_method, otp);
    }, 3000);
    setTimeout(
      () => {
        clearInterval(findTokenInterval);
        setVerificationProcess(false);
      },
      2 * 60 * 1000,
    );
  };

  const getJWT = async (tokenInterval, login_method, otp) => {
    try {
      let data = await axios.post(`v1/generateJWT`, {
        phoneNo: Form[0].fields[3].value,
        otp: otp,
        login_method,
      });
      if (!data.data.is_success) return;
      localStorage.setItem("homeshiksha-tutor-jwt", JSON.stringify(data.data.data.token));
      clearInterval(tokenInterval);
      setVerificationProcess(false);
      navigate("/dashboard");
      window.location.reload();
    } catch (error) { }
  };

  const handleWhatsAppLogin = (e) => {
    e.preventDefault();
    logEvent(EVENTS.WHATSAPP_REGISTER.event_name);
    setVerificationProcess(true);
    registerAndGetOTP("whatsapp");
  };

  const handleVerifyBySMS = () => {
    setSmsOtpVerification(() => true);
    setVerificationProcess(() => true);
    setShowResendOtp(() => false);
    registerAndGetOTP("sms");
    logEvent(EVENTS.SMS_REGISTER.event_name);
    setTimeout(
      () => {
        setShowResendOtp(() => true);
      },
      30 * 1000,
    );
  };

  const handleOtpChange = (e) => {
    let otp = e.target.value;
    setOtp(() => otp);
    if (otp.length === 6) {
      setVerificationProcess(() => true);
      axios
        .post(`v1/verifyOtp`, { phoneNo: Form[0].fields[3].value, otp: otp })
        .then((data) => {
          checkForJWT("sms", otp);
        })
        .catch((err) => { });
    } else {
      setVerificationProcess(() => false);
    }
  };

  const handledropDownOptionClick = useCallback(
    (field, index, step, option) => {
      setErrors((prev) => ({ ...prev, [field.name || "checkbox"]: "" }));
      setForm((prevForm) => {
        const newForm = [...prevForm];
        newForm[step].viewed = true;
        newForm[step].fields[index].value = option;

        try {
          if (newForm[step].fields[index + 1].type === "dropDown" && newForm[step].fields[index + 1].value === "") {
            newForm[step].fields[index + 1].open = true;
          }
        } catch (error) { }

        return newForm;
      });
    },
    [setForm, setErrors],
  );

  const Step = (step) => (
    <div className="form--container">
      <form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          let newForm = [...Form];
          let emptyField = [];
          let newErrors = {};

          newForm[step].fields.forEach((inpurField) => {
            const fieldName = inpurField.name || "checkbox";
            if (inpurField.name === "Mobile") {
              if (!inpurField.value || inpurField.value.length === 0) {
                newErrors[fieldName] = "Mobile number is required";
                emptyField.push(fieldName);
              } else if (inpurField.value.length < 10) {
                newErrors[fieldName] = "Mobile number must be 10 digits";
                emptyField.push(fieldName);
              } else {
                logEvent(EVENTS.GIVEN_MOBILE_NO.event_name);
              }
            } else if (inpurField.name === "Email" || inpurField.type === "email") {
              const emailVal = typeof inpurField.value === "string" ? inpurField.value.trim() : "";
              const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
              if (!emailVal) {
                newErrors[fieldName] = "Email is required";
                emptyField.push(fieldName);
              } else if (!emailRegex.test(emailVal)) {
                newErrors[fieldName] = "Please enter a valid email address";
                emptyField.push(fieldName);
              }
            } else if (inpurField.type === "checkbox") {
              if (!inpurField.value) {
                newErrors[fieldName] = "You must accept the terms and conditions";
                emptyField.push(fieldName);
              }
            } else {
              const isEmpty = typeof inpurField.value === "string" ? inpurField.value.trim().length === 0 : !inpurField.value;
              if (isEmpty) {
                newErrors[fieldName] = `${fieldName.trim()} is required`;
                emptyField.push(fieldName);
              }
            }
          });

          setErrors(newErrors);

          if (emptyField.length === 0) {
            logEvent(EVENTS["HS_STEP_NO_" + (step + 1)].event_name);
            setCurrentStep((pre) => step + 1);
            setForm((pre) => {
              newForm[step].filled = true;
              newForm[step + 1].viewed = true;
              try {
                if (newForm[step + 1].fields[0].type === "dropDown" && newForm[step + 1].fields[0].value === "") {
                  newForm[step + 1].fields[0] = {
                    ...newForm[step + 1].fields[0],
                    open: true,
                  };
                }
              } catch (error) { }

              return newForm;
            });
          } else {
            setForm((pre) => {
              newForm[step].fields = newForm[step].fields.map((inputField) => {
                if (inputField.value === "") return { ...inputField, open: true };
                return inputField;
              });
              return newForm;
            });
          }
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        {Form[step].fields.map((field, index, stepArray) => {
          let options = field.options;
          let formComponent = <div>input failed </div>;
          switch (field.type) {
            case "dropDown":
              formComponent = (
                <div
                  className="selection--wrapper"
                  onClick={(e) => {
                    setForm((pre) => {
                      let newForm = [...pre];
                      newForm[step].fields[index] = {
                        ...field,
                        open: !field.open,
                      };
                      return newForm;
                    });
                  }}
                  onChange={(e) => {
                    if (!e.target.value) return;
                    handledropDownOptionClick(field, index, step, e.target.value);
                  }}
                >
                  {field.open ? (
                    options.map((option, optionIndex) => (
                      <div className={`selection--option-wrapper ${field.open ? "showDropdown" : "hideDropdown"}`}>
                        <input
                          type="radio"
                          id={`${field.name}-${optionIndex}`} // Ensure unique IDs for each radio button
                          value={option}
                          checked={option === field.value}
                          name={field.name}
                          required
                          style={{ cursor: "pointer" }}
                        />
                        <label
                          htmlFor={`${field.name}-${optionIndex}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handledropDownOptionClick(field, index, step, option);
                          }}
                        >
                          {makeTitle(option)}
                        </label>
                      </div>
                    ))
                  ) : field.value !== "" ? (
                    <div className={`selection--option-wrapper`}>
                      <input type="radio" readOnly={true} checked />
                      {makeTitle(field.value)}
                    </div>
                  ) : (
                    field.placeHolder
                  )}
                </div>
              );
              break;
            case "address":
              formComponent = (
                <div>
                  <Autocomplete
                    apiKey={apiKey}
                    style={{ width: "99%" }}
                    onPlaceSelected={(place) => {
                      let addressComponents = place.address_components;
                      let locality = addressComponents.map((geo) => geo.long_name).join(", ");
                      let pinCode = addressComponents.find((component) => component.types.includes("postal_code"));
                      let city = addressComponents.find(
                        (component) => component.types.includes("locality") && component.types.includes("political"),
                      );
                      let state = addressComponents.find(
                        (component) =>
                          component.types.includes("administrative_area_level_1") &&
                          component.types.includes("political"),
                      );
                      let latitude = place.geometry.location.lat();
                      let longitude = place.geometry.location.lng();
                      let value = {
                        pincode: pinCode ? pinCode.short_name : " ",
                        city: city ? city.long_name : " ",
                        state: state ? state.long_name : " ",
                        locality: locality,
                        latitude: latitude,
                        longitude: longitude,
                        gmap_meta_data: JSON.stringify(addressComponents),
                      };
                      setErrors((prev) => ({ ...prev, [field.name || "checkbox"]: "" }));
                      setForm((pre) => {
                        let newForm = [...pre];
                        newForm[step].viewed = true;
                        newForm[step].fields[index] = {
                          ...field,
                          value: value,
                        };
                        return newForm;
                      });
                    }}
                    options={{
                      types: [
                        // "hospital",
                        // "pharmacy",
                        // "bakery",
                        // "sublocality",
                        // ,
                        // "landmark",
                        // "locality",
                        // "postal_code",
                        // "postal_code_prefix",
                        // "postal_code_suffix",
                        // "postal_town",
                        // "street_address",
                        // "street_number",
                        // "sublocality",
                        // "sublocality_level_1",
                        // "sublocality_level_2",
                        // "sublocality_level_3",
                        // "sublocality_level_4",
                        // "sublocality_level_5",
                        // "subpremise",
                        // "town_square",
                      ],
                      componentRestrictions: { country: "IN" },
                    }}
                    placeholder={field.placeHolder}
                  />
                </div>
              );
              break;
            case "verificationBtn":
              if (!smsOtpVerification) {
                formComponent = (
                  <div>
                    <div className="login-btns-wrapper register-btns-wrapper" id="whatsapp-login-btn">
                      <button
                        type="button"
                        className="registerPrimaryButton"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={(e) => {
                          handleWhatsAppLogin(e);
                        }}
                      >
                        <img src="./whatsapp-icon.svg" alt="whats app icon" />
                        Verify with Whatsapp
                      </button>
                      <img
                        src="./book-loader.gif"
                        style={{ width: "auto" }}
                        alt=" Loading . . .  "
                        className={`${verificationProcess ? "" : "in"}active-img`}
                      />
                    </div>
                    <div className="login-btns-wrapper register-btns-wrapper">
                      <button
                        type="button"
                        className="registerPrimaryButton"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={(e) => {
                          handleVerifyBySMS();
                        }}
                      >
                        Verify using the SMS OTP
                      </button>
                      <img
                        src="./book-loader.gif"
                        style={{ width: "auto" }}
                        alt=" Loading . . .  "
                        className={`${verificationProcess ? "in" : "in"}active-img`}
                      />
                    </div>
                  </div>
                );
              } else {
                formComponent = (
                  <>
                    <div className="input-loading-wrapper" style={{ flexDirection: "column" }}>
                      {showOtpError && <div className="errorAlert">{showOtpError} </div>}
                      <input
                        type="tel"
                        placeholder="Enter your OTP"
                        className="loginInputField"
                        value={otp}
                        onChange={(e) => {
                          handleOtpChange(e);
                        }}
                        style={{ textAlign: "center" }}
                      />
                      <div className="genetating-otp-loader">
                        {verificationProcess && <img src="./book-loader.gif" alt=" Loading . . .  " />}
                      </div>
                    </div>
                    <div className="login-btns-wrapper">
                      <div>
                        {showResendOtp && (
                          <button
                            type="button"
                            className="loginPrimaryButton"
                            onClick={() => {
                              handleVerifyBySMS();
                            }}
                          >
                            Resend OTP
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                );
              }
              break;
            case "checkbox":
              formComponent = (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <input
                    required
                    type={field.type}
                    id={`${field.name}`}
                    name={`${field.name}`}
                    placeholder={`${field.placeHolder}`}
                    value={field.value}
                    onChange={(e) => {
                      let value = !field.value;
                      setErrors((prev) => ({ ...prev, checkbox: "" }));
                      setForm((pre) => {
                        let newForm = [...pre];
                        newForm[step].viewed = true;
                        newForm[step].fields[index] = {
                          ...field,
                          value: value,
                        };
                        return newForm;
                      });
                    }}
                  />
                  <span style={{ marginLeft: "8px", fontWeight: "600" }}>
                    I have read and accept{" "}
                    <span
                      onClick={() => {
                        window.open("https://homeshiksha.com/tutors-terms-and-conditions/", "_blank");
                      }}
                      style={{
                        color: "navy",
                        fontSize: "18px",
                        cursor: "pointer",
                      }}
                    >
                      Tutor Terms and Conditions.
                    </span>
                  </span>
                </div>
              );
              break;
            default:
              formComponent = (
                <input
                  required
                  type={field.type}
                  id={`${field.name}`}
                  name={`${field.name}`}
                  placeholder={`${field.placeHolder}`}
                  value={field.value}
                  maxLength={field.name === "Mobile" ? 10 : undefined}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (field.name === "Mobile") {
                      value = value.replace(/\D/g, "");
                      if (value.length > 10) return;
                    }

                    setErrors((prev) => ({ ...prev, [field.name || "checkbox"]: "" }));
                    setForm((pre) => {
                      let newForm = [...pre];
                      newForm[step].viewed = true;
                      newForm[step].fields[index] = {
                        ...field,
                        value: value,
                      };
                      return newForm;
                    });
                  }}
                />
              );
          }

          return (
            <div key={index}>
              <div className="input-group">
                {field.name && <label htmlFor={`${field.name}`}>{!field.open ? field.name : field.placeHolder}</label>}
                {formComponent}
                {errors[field.name || "checkbox"] && (
                  <span className="validation-error-message">
                    {errors[field.name || "checkbox"]}
                  </span>
                )}
              </div>
            </div>
          );
        })}

        <div className="form-buttons-wrapper">
          {currentStep > 0 && currentStep < 3 && (
            <button className="secondary-btn" type="button" onClick={(e) => setCurrentStep(step - 1)}>
              Previous
            </button>
          )}
          {currentStep < 3 && (
            <button className="primary-btn" type="submit">
              Next
            </button>
          )}
        </div>
      </form>
    </div>
  );

  const styles = {
    bgColor: "white",
    titleTextColor: "Black",
    rowTitleColor: "Black",
    rowContentColor: "grey",
    arrowColor: "black",
    rowBorderColor: "orange",
  };

  const onClickRow = (rowIndex) => {
    setActiveRow(rowIndex === activeRow ? null : rowIndex);
  };

  useEffect(() => {
    logPageView("Register Page");
    let jwt = JSON.parse(localStorage.getItem("homeshiksha-tutor-jwt"));
    if (!jwt) {
      localStorage.setItem("userDetails", JSON.stringify({}));
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/dashboard");
      window.location.reload();
    }
  }, []);

  return (
    <main className="main need-a-tutor">
      <section className="top-session">
        <div className="need-a-tutor-top-session--rightpart-wrapper">
          <div className="need-a-tutor-top-session--rightpart--form-wrapper">
            <div className="form_title">Become a tutor</div>
            <div className="form-status--wrapper">
              <div className="steps-wrapper">
                {Form.map((item, index) => (
                  <div className="step-status-wrapper" key={index}>
                    <div
                      onClick={(e) => {
                        if (Form[index].viewed) setCurrentStep((pre) => index);
                      }}
                    >
                      Step {index + 1}{" "}
                    </div>
                    <div
                      onClick={(e) => {
                        if (Form[index].viewed) setCurrentStep((pre) => index);
                      }}
                      className={`step-status-circle ${Form[index].viewed ? "blue-border" : ""
                        } ${Form[index].filled ? "blue-bg" : ""}`}
                    ></div>
                  </div>
                ))}
              </div>
              <div className="line-wrapper-under-steps-wrapper"></div>
            </div>
            <div className="form--wrapper">{Step(currentStep)}</div>
          </div>
        </div>
        <div className="need-a-tutor-top-session--leftpart-wrapper">
          <div className="need-a-tutor-biglogo--wrapper">
            <img src="./become-tutor-form-header-side-4x.png" alt="tutor-main-side-pic" />
            <div className="need-a-tutor-biglogo--title">
              Elevating <span style={{ color: "rgba(242, 192, 12, 1)" }}>Education</span>,
              <br /> One <span style={{ color: "rgba(242, 192, 12, 1)" }}>Home</span> at a Time
            </div>
          </div>
        </div>
      </section>

      <PlatformReviewComponent></PlatformReviewComponent>

      <section className="small-section">
        <div className="small-section--text">
          <div className="small-section--text-left"></div>
        </div>
      </section>

      <section className="endorsed-and-certified-section">
        <div className="endorsed-and-certified-section--imgs-wrapper">
          <div className="endorsed-by-india-section-section-left-text">
            <h1 className="text-top">We are now incubated</h1>
            <h1 className="text-middle">with</h1>
            <h1 className="text-city">IIM Bangalore</h1>
          </div>
          <div className="endorsed-by-india-section-section-right-img">
            <img src="./iimb-logo.png" alt="msme img" className="img-2" />
          </div>
        </div>
      </section>

      <section className="certified-by-india-section">
        <div className="certified-by-india-section--title">Certified by Indian Government</div>
        {/* <div className="certified-by-india-section--midline"></div> */}
        <div className="certified-by-india-section--imgs-wrapper">
          <div>
            <img src="./MSME.svg" alt="msme img" className="img-3" />
          </div>
          <div>
            <img src="./startup-India.svg" alt="start up india img" className="img-4" />
          </div>
        </div>
      </section>

      <section className="small-section">
        <WhyChooseHomeShiksha></WhyChooseHomeShiksha>
      </section>

      <section className="small-section">
        <div className="video-container">
          <iframe
            width="100%"
            height="600px"
            src="https://www.youtube.com/embed/YZfGBhcAMJA?si=1TbENQdpB5omQnNJ"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </section>

      <section className="small-section">
        <div className="small-section--text">
          <div className="small-section--text-left">
            <div className="small-section--text-left--title">
              How It <span style={{ color: "rgba(242, 192, 12, 1)" }}>Works</span> ?
            </div>
          </div>
        </div>
      </section>

      {/* <section className="Image_ICON_Container">
        <img src="How-it-works-medium.svg" className="ICON_FLEX" alt="how-it-works" />
      </section> */}

      <section className="Image_ICON_Container_Large">
        <img src="How-to-choose-large.svg" className="ICON_FLEX_Large" alt="how-it-works" />
      </section>

      <section className="Image_ICON_Container_Small">
        <img src="How-to-choose-small.svg" className="ICON_FLEX_Large_Small" alt="how-it-works" />
      </section>

      <section className="small-section">
        <div className="small-section--text">
          <div className="small-section--text-left">
            <div className="small-section--text-left--title">
              Frequent asked <span style={{ color: "rgba(242, 192, 12, 1)" }}>Questions</span>{" "}
            </div>
          </div>
        </div>
      </section>

      <section>
        <Faq data={FaqData} styles={styles} config={config} />
      </section>

      <section className="small-section">
        <div className="small-section--text">
          <div className="small-section--text-left">
            <div className="small-section--text-left--title">
              Hear from our <span style={{ color: "rgba(242, 192, 12, 1)" }}>Tutors</span>
            </div>
          </div>
        </div>
      </section>

      <TutorsReviewComponent></TutorsReviewComponent>

      <section className="small-section">
        <div className="small-section--text">
          <div className="small-section--text-left"></div>
        </div>
      </section>
      {/* <Footer /> */}
    </main>
  );
}
